module.exports = __webpack_public_path__ + "media/images/hitfun3/icon.search.white-3d4edcce23a9bb39c8bf1b54fb3f30b3.svg";